import { RouteObject } from "react-router";

import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const groupsRoutes: RouteObject = {
	path: "groups/*",
	children: [
		{
			index: true,
			lazy: async () => {
				const { GroupsPage } = await import("./pages");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={(boundary) => (
								<PageError
									error={boundary.error}
									componentStack={boundary.componentStack}
									reset={() => boundary.resetError()}
								/>
							)}
						>
							<GroupsPage />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
		{
			path: ":id/:tab?",
			lazy: async () => {
				const { GroupPage } = await import("./pages");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={(boundary) => (
								<PageError
									error={boundary.error}
									componentStack={boundary.componentStack}
									reset={() => boundary.resetError()}
								/>
							)}
						>
							<GroupPage />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
	],
};
